/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { ClassChildJson } from '@/types/domain/class/entities/classChildEntity';
import type { ClassStateType } from '@/types/domain/class/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: ClassStateType = {
  classChildList: [],
};

/**
 * クラスSlice
 */
export const classSlice = createSlice({
  name: 'class',
  initialState,
  reducers: {
    /** クラス子どもリストをセット */
    setClassChildList: (
      state,
      action: PayloadAction<ClassChildJson[]>,
    ) => {
      state.classChildList = action.payload;
    },
    /** 作成 */
    createClassChildStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.classChildList = service.class.createClassChildStore(
        state.classChildList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateClassChildStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.classChildList = service.class.updateClassChildStore(
        state.classChildList,
        action.payload,
      );
    },
    /** 削除 */
    deleteClassChildStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.classChildList = service.class.deleteClassChildStore(
        state.classChildList,
        action.payload,
      );
    },
  },
});
